import { render, staticRenderFns } from "./from-employee.vue?vue&type=template&id=01bd5021&scoped=true&"
import script from "./from-employee.vue?vue&type=script&lang=js&"
export * from "./from-employee.vue?vue&type=script&lang=js&"
import style0 from "./from-employee.vue?vue&type=style&index=0&id=01bd5021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bd5021",
  null
  
)

export default component.exports